<template>
  <q-dialog v-model="show" persistent>
    <q-card class="padding-horizontal-large">
      <q-form
        @submit="submitForm"
        @reset="$emit('reset')"
        ref="myForm">
        <q-toolbar>
          <q-toolbar-title>
            <span v-if="update" class="text-weight-bold">Modification </span>
            <span v-else class="text-weight-bold">Ajout </span>
            d'une boisson
          </q-toolbar-title>
          <q-btn flat round dense icon="close" @click="$emit('close')" />
        </q-toolbar>

        <q-separator inset />

        <q-card-section>
            <q-input v-model="drink.name" label="Nom de la boisson" :dense="dense" cypress="drinkName" 
            :rules="[val => !!val || 'Ce champ ne doit pas être vide']"
            lazy-rules/>
            <q-select v-model="drink.category" label="Catégorie" :dense="dense" option-value="id" option-label="name" :options="categories" required/>
            <q-input v-model.number="drink.start_price" label="Prix de la boisson" type="number" step="0.05" :dense="dense" cypress="drinkStartPrice" 
            :rules="[val => !!val || 'Ce champ ne doit pas être vide']"
            :error="!isStartPriceValid"
            bottom-slots
            error-message="Doit être entre le prix max et le prix min"/>
            <q-input v-model.number="drink.lower_price" label="Prix minimum" type="number" step="0.05" :dense="dense" cypress="drinkLowerPrice" 
            :rules="[val => !!val || 'Ce champ ne doit pas être vide']" 
            :error="!isLowerPriceValid"
            bottom-slots
            error-message="Doit être inférieure au prix max" />
            <q-input v-model.number="drink.higher_price" label="Prix maximum" type="number" step="0.05" :dense="dense" cypress="drinkHigherPrice" 
            :rules="[val => !!val || 'Ce champ ne doit pas être vide']"
            :error="!isHigherPriceValid"
            bottom-slots
            error-message="Doit être supérieur au prix min"/>
        </q-card-section>

        <q-card-actions align="right">
          <template v-if="update">
            <q-btn label="Annuler" color="secondary" flat @click="$emit('close')" />
            <q-btn label="Enregistrer" type=submit color="primary" flat />
          </template>
          <template v-else>
            <q-btn label="Réinitialiser" type="reset" color="secondary" flat class="q-ml-sm" />
            <q-btn label="Ajouter" type="submit" color="primary" flat cypress="submitButton"/>
          </template>
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>
<script>
import {getCategories} from '~/services/drinks'
export default {
  name: "DrinkDialog",
  props: {
    show: Boolean,
    drink: Object,
    update: Boolean,
  },
  data() {
    return {
      model: null,
      categories: [],
      dense: false,
      
    };
  },
  async created() {
    const response = await getCategories()
    if (response.status === 200){
      this.categories = response.data
    }
  },
  methods: {
    submitForm() {
      if(this.isStartPriceValid && this.isLowerPriceValid && this.isHigherPriceValid && this.drink.category) {
        if (this.update) {
          this.$emit('update')
        } else {
          this.$emit('submit')
        }
      } else {
         this.$q.notify({
          color: 'red-4',
          textColor: 'white',
          icon: 'fas fa-exclamation-circle',
          message: 'Un champ est mal renseigné',
          position: 'top-right'
        });
      }
    },
  },
  computed: {
    isStartPriceValid() {
      let test1 = true;
      let test2 = true;
      if (!!this.drink.start_price){
        if(!!this.drink.lower_price) {
          test1 = this.drink.start_price >= this.drink.lower_price;
        }
        if(!!this.drink.higher_price) {
          test2 = this.drink.start_price <= this.drink.higher_price;
        }
        return test1 && test2;
      }
      return true;
    },
    isLowerPriceValid() {
      if(!!this.drink.lower_price && !!this.drink.higher_price) {
        const test = this.drink.lower_price < this.drink.higher_price;
        return test;
      }
      return true;
    },
    isHigherPriceValid() {
      if(!!this.drink.higher_price && !!this.drink.lower_price){
        const test = this.drink.lower_price < this.drink.higher_price;
        return test;
      }
      return true;
    },
  },
}
</script>
